import { render, staticRenderFns } from "./serverDimensionData.vue?vue&type=template&id=57603c80&scoped=true&"
import script from "./serverDimensionData.vue?vue&type=script&lang=js&"
export * from "./serverDimensionData.vue?vue&type=script&lang=js&"
import style0 from "./serverDimensionData.vue?vue&type=style&index=0&id=57603c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57603c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57603c80')) {
      api.createRecord('57603c80', component.options)
    } else {
      api.reload('57603c80', component.options)
    }
    module.hot.accept("./serverDimensionData.vue?vue&type=template&id=57603c80&scoped=true&", function () {
      api.rerender('57603c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/serverDimensionData.vue"
export default component.exports